module.exports = __webpack_public_path__ + "img/checkmark.41917f17.svg";